import {
    SET_VENDORS_LOADING,
    REMOVE_VENDORS_LOADING,
    GET_VENDOR,
    SET_VENDOR_FIELD
} from "../../types";

const initialState = {
    dropdowns: {}, //	Dropdown list
    data: {}, //    Any default vaule here is used for vendor  add
    loading: false
};

export default function(state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_VENDORS_LOADING:
            return {
                ...state,
                loading: true
            };
        case REMOVE_VENDORS_LOADING:
            return {
                ...state,
                loading: false
            };
        case GET_VENDOR:
            return {
                ...state,
                data: payload
            };
        case SET_VENDOR_FIELD:
            return {
                ...state,
                data: { ...payload }
            };
        default:
            return state;
    }
}
